import { useCompanyInfo } from "@/hooks/useCompanyInfo";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PrivacyHrContent } from "@/legal/privacy/hr";
import { PrivacyEnContent } from "@/legal/privacy/en";
import { LocalePicker } from "@/components/shared/LocalePicker";

const Privacy = () => {
  const co = useCompanyInfo();
  const { i18n } = useTranslation();
  const contactEmail = co.email || "info@thenea.app";
  const dpoEmail = co.dpoEmail || contactEmail;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const locale = (i18n.resolvedLanguage || i18n.language || "hr").toLowerCase();
  const Content = locale.startsWith("en") ? PrivacyEnContent : PrivacyHrContent;

  return (
    <div className="min-h-screen bg-background py-20 px-4">
      <div className="container max-w-3xl mx-auto">
        <div className="flex justify-end mb-4">
          <LocalePicker />
        </div>
        <Content company={co} contactEmail={contactEmail} dpoEmail={dpoEmail} />
      </div>
    </div>
  );
};

export default Privacy;
